import { LanguageContext } from "App";
import React, { useState, useMemo, useContext } from "react";
import Select from "react-select";
import countryList from "react-select-country-list";

function CountrySelector({ SetNationality }) {
  const [value, setValue] = useState("");
  const options = useMemo(() => countryList().getData(), []);
  const { translations } = useContext(LanguageContext);

  const changeHandler = (value) => {
    SetNationality(value.label);
    setValue(value);
  };

  return (
    <Select
      placeholder={translations.userManagementPgInputsNationality}
      options={options}
      value={value}
      onChange={changeHandler}
      styles={{
        placeholder: (provided) => ({
          ...provided,
          fontSize: "18px", 
          opacity: 0.8,
        }),
      }}
    />
  );
}

export default CountrySelector;
